import * as types from "./types";

const INITIAL_STATE = {
  list: [],
  meta: {},
};

const profileEditRequests = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_PROFILE_EDIT_REQUESTS_RESPONSE:
      return {
        ...state,
        list: action.payload.list,
        meta: action.payload.meta,
      };

    default:
      return state;
  }
};

export default profileEditRequests;
